import { useState, useEffect } from 'react';
import { getAttributePrices } from '../../../utils/priceHelpers';

export function usePriceCalculator(
  actualAttributes: any,
  hasLoaded: boolean,
  configActiveMenu: boolean
) {
  const [actualPrice, setActualPrice] = useState(0);

  function calcPrice() {
    // Read selections from mock attributes (source of truth — never wiped by Redux)
    // and prices directly from products.json
    const prices = getAttributePrices(actualAttributes);
    let total = 0;

    console.log('[usePriceCalculator] ===== ОБЧИСЛЕННЯ ЦІНИ =====');
    for (const p of prices) {
      console.log(`[usePriceCalculator] ${p.name}:`, {
        selectedLabel: p.selectedLabel,
        priceId: p.priceId,
        unitPrice: p.unitPrice,
        quantity: p.quantity,
        subtotal: p.subtotal,
      });
      total += p.subtotal;
    }
    const finalPrice = Number(total.toFixed(2));
    console.log(`[usePriceCalculator] ЗАГАЛЬНА ЦІНА: $${finalPrice}`);
    console.log('[usePriceCalculator] ================================');
    setActualPrice(finalPrice);
  }

  useEffect(() => {
    calcPrice();
  }, [configActiveMenu]);

  useEffect(() => {
    if (hasLoaded) {
      calcPrice();
    }
  }, [actualAttributes]);

  return actualPrice;
}
